import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CancelOrderService } from '../../services/cancel-order.service';
import { CancelOrderGarment } from '../../models/cancel-order.model';
import { GtrakAuthService } from "../../../authentication/services/gtrak-auth.service";
import { RequestParams } from '../../../../common/rest-api/models/request-params';

@Component({
    selector: 'app-employee-cancel-order-page',
    templateUrl: 'employee-cancel-order.page.html',
    styleUrls: [
      './employee-cancel-order.page.scss',
    ]
  })
  export class EmployeeCancelOrderPage implements OnInit  {

    constructor(
      private router: Router,
      private route: ActivatedRoute,
        public authService: GtrakAuthService,
      private cancelOrderService: CancelOrderService,
    ) { }
    currentDate = new Date();
    cancelOrders: any[] = [];
    totalLossCharge: number = 0;
    loaded: boolean;
    customerName:string="";
    departmentName:string="";
    requestParams:any;
    costCenterId:string;
    employeeCode:string;
    stopCode:string;
    Dept:string;
    customerId:string;
    header:string;
    departmentCode:string;
     public viewChange: boolean = false;

    async ngOnInit() {
      this.loaded = false;
        this.requestParams = new RequestParams();
      this.stopCode=localStorage.getItem('stopCode');
     this.employeeCode= this.route.snapshot.params.id;
     this.Dept=this.route.snapshot.params.did;
     this.customerId=this.route.snapshot.params.cid;
     if(this.authService.user.isCostCenterUser){
      this.requestParams.filters.CostCenterUser=localStorage.getItem('CostCenterUser');
     }
      if(this.route.snapshot.params.csid !=undefined){
           this.header='Cost Center Cancel Order ';
             await this.cancelOrderService.getForCostCenter(this.route.snapshot.params.id, this.route.snapshot.params.did, this.route.snapshot.params.cid, this.route.snapshot.params.csid).then((cancelOrder) => {
              this.cancelOrders = cancelOrder;
            });
          }
      else{
            this.header='Employee Cancel Order ';
            await this.cancelOrderService.getForEmployeeCO(this.route.snapshot.params.id, this.route.snapshot.params.did, this.route.snapshot.params.cid, this.requestParams).then((cancelOrder) => {
            this.cancelOrders = cancelOrder;
          });
        }
        this.loaded = true;
        
     if(this.cancelOrders!=undefined){
        if(this.cancelOrders.length>0){
            this.customerName=this.cancelOrders[0][0].customerName;
            this.departmentName=this.cancelOrders[0][0].departmentName;
        }
      for (let i = 0; i < this.cancelOrders.length; i++) {
        let woLossCharge = 0;
        const cancelOrderGarments = this.cancelOrders[i] as unknown as CancelOrderGarment[];
        for (let j = 0; j < cancelOrderGarments.length; j++) {
          if(cancelOrderGarments[j].dateCollected === null) {
            woLossCharge += parseFloat(cancelOrderGarments[j].lossCharge);
            this.totalLossCharge += parseFloat(cancelOrderGarments[j].lossCharge);
            woLossCharge = Math.round(woLossCharge * 100) / 100;
            this.totalLossCharge = Math.round(this.totalLossCharge * 100) / 100;
          }
        }
        this.cancelOrders[i].lossCharge = woLossCharge;
      }

      
    }
     this.loaded = true;
  }
   changePrinterView(): void {
    this.viewChange = !this.viewChange;
    setTimeout(() => {
      print();
    }, 1000); 
  }

doesFreqRunOnDate(strFrequency: string, forDate: Date, vbaseDate: Date): boolean {
  if (!strFrequency || strFrequency.trim() === '') {
    return false;
  }

  let tmp = Math.floor(
    Math.abs(
      (forDate.getTime() - vbaseDate.getTime()) / (1000 * 60 * 60 * 24)
    )
  );

  const idx = tmp % strFrequency.length;

  return strFrequency.charAt(idx) === '1';
}
  }